// Configurazione per l'ambiente di produzione cliente
// (deploy dal solo branch `main` su `app.lsr.vetlaserscan.com`).
export const environment = {
  production: true,
  apiUrl: 'https://backend.lsr.vetlaserscan.com/oye',
  api2Url: 'https://backend.lsr.vetlaserscan.com'
};
